// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/',
    name: 'Пристрої',
    component: () => import('@/views/DevicesPage.vue'), // Завантаження DevicesPage динамічно
    meta: { requiresAuth: true }, // Додаткові властивості
  },
  {
    path: '/devices/:id/files',
    name: 'Файли пристрою',
    component: () => import('@/views/DeviceFilesPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/devices/:id/config',
    name: 'Конфіг пристрою',
    component: () => import('@/views/DeviceConfigPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chanels',
    name: 'ТГ Канали',
    component: () => import('@/views/ChanelsPage.vue'), // Завантаження ChanelsPage динамічно
    meta: { requiresAuth: true }, // Додаткові властивості
  },
  {
    path: '/:pathMatch(.*)*', // Сторінка 404
    name: 'NotFound',
    component: () => import('@/views/NotFoundPage.vue'),
  },
  {
    path: '/audio',
    name: 'Перевірка мікрофона',
    component: () => import('@/views/StreamPage.vue'), 
    meta: { requiresAuth: true }, // Додаткові властивості
  },
  {
    path: '/users',
    name: 'Користувачі',
    component: () => import('@/views/UsersPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Налаштування',
    component: () => import('@/views/SettingsPage.vue'),
    meta: { requiresAuth: true },
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Навігаційна перевірка (middleware)
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token');
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login'); // Перенаправлення на сторінку входу
  } else {
    next();
  }
});

export default router;
